import {lazy, trigger, filter} from './lang.js';
import {doc} from './documentation.js';

doc(
    "search",
    {
        "name": "tag or name to search for",
    },
    "Filters out triggers to only tracks of given tag or name (ex: search(\"kick\") returns only kick triggers"
);

export const search = (name) => {
    return (...args) => {
        let _name = lazy(name, ...args);
        let [stepData, stepNumber, time, effect] = args;

        if (stepData && stepData.track) {
            let {track} = stepData;
            if (track.instrument) {
                if (track.getName().toLowerCase().includes(_name.toLowerCase())) {
                    return filter(true);
                }
            } else if (track.sample.tags.some(
                x => x.toLowerCase().includes(_name.toLowerCase()))) {
                return filter(true);
            }
        }

        return filter(false);
    };
};
